import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { pageBreadcrumbStyles } from "@insite/content-library/Components/PageBreadcrumbs";
import { css } from "styled-components";

pageBreadcrumbStyles.breadcrumbs = mergeToNew(pageBreadcrumbStyles.breadcrumbs, {
    css: css`
        flex-wrap: wrap;
    `,
});
